import parsePhoneNumberFromString, { isSupportedCountry } from 'libphonenumber-js';
import type { PhoneNumber } from 'libphonenumber-js';
import type { Country } from '@tectonics/prs/country';

const parseForCountry = (country: Country, phoneNumber: string): PhoneNumber | undefined => {
  const upperCountry = country.toUpperCase();
  if (!isSupportedCountry(upperCountry)) return undefined;
  return parsePhoneNumberFromString(phoneNumber, { defaultCountry: upperCountry, extract: false });
};

export function toInternationalPhoneNumber(country: Country, phoneNumber: string): string {
  if (!phoneNumber.trim()) return '';

  return parseForCountry(country, phoneNumber)?.number ?? phoneNumber;
}

export function toNationalPhoneNumber(country: Country, phoneNumber: string): string {
  if (!phoneNumber.trim()) return '';

  return parseForCountry(country, phoneNumber)?.nationalNumber ?? phoneNumber;
}
